import React from 'react';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import RootAdmin from '../../../components/layouts/RootAdmin';
import Timeline from '../../../components/fragments/admin/ticket/Timeline';
import Form from '../../../components/fragments/admin/ticket/Form';
import HeaderPage from '../../../components/elements/HeaderPage';
import { getFetcher } from '../../../services/api';
import Error from '../../../components/fragments/Error';
import Chat from '../../../components/fragments/admin/ticket/Chat';

export default function DetailPage() {
  const { id } = useParams();
  const { data, isLoading, error, mutate } = useSWR(`/api/tickets/find/${id}`, getFetcher);

  if (error?.status === 404) return <Error code={404} header="Not Found" message="Ticket not found." />;
  if (error?.status === 500) return <Error code={500} header="Server Error" message="Something went wrong." />;

  return (
    <RootAdmin>
      <HeaderPage title={`Ticket: ${data?.subject}`} subtitle="Ticket Details" />
      <div className="grid grid-cols-1 md:grid-cols-5 gap-3 pt-3">
        <Timeline data={data} isLoading={isLoading} mutate={mutate} className="col-span-3" />
        <Chat ticketId={id} messages={data?.messages} mutate={mutate} className="col-span-2" />
      </div>
    </RootAdmin>
  );
}
